import * as api from "./middleware/api.middleware";
const serviceUrl = "login";

export function getExistingUserVerify2FAService(
  id: number,
  otpNumber: string,
  username: string,
  password: string
) {
  const user_name = username;
  const pass_word = password;
  const encodedCredentials = btoa(`${user_name}:${pass_word}`);
  const authHeader = `Basic ${encodedCredentials}`;

  const getResponse = api.post<any>(
    `${serviceUrl}/verify?token=${otpNumber}&user_id=${id}`,
    {
      user_id: id,
      token: otpNumber,
    },
    {
      Authorization: authHeader,
    }
  );
  return getResponse;
}
